import { createContext, useContext } from "react";

const MyAccountContext = createContext(null);

export const useMyAccount = () => {
  const context = useContext(MyAccountContext);

  if (context === null) {
    throw new Error("useMyAccount must be used inside MyAccountLayout");
  }

  return context;
};

export default MyAccountContext;
